import React from 'react';
import classNames from 'classnames';
import { SegmentsMenuContent } from './SegmentsMenuContent';
import './NavMenuDesktop.scss';
import { useDelayedOffSwitch } from '../../../../../util/useDelayedOffSwitch';
var SpeechBubbleTip = function SpeechBubbleTip() {
  return /*#__PURE__*/React.createElement("div", {
    className: "speech-bubble-tip"
  });
};
export var NavMenuDesktop = function NavMenuDesktop(_ref) {
  var open = _ref.open,
    navbarData = _ref.navbarData;
  var transition = useDelayedOffSwitch(open, 200);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('NavMenuDesktop', {
      open: open,
      transition: transition
    })
  }, /*#__PURE__*/React.createElement(SpeechBubbleTip, null), /*#__PURE__*/React.createElement(SegmentsMenuContent, {
    segments: navbarData.segments,
    maxColumnLength: 6
  }));
};